export const CONNECT_EXTERNAL_OAUTH_URL = `
    mutation ExternalAuthUrl($channel_type: ExternalConnectEnum!) {
        externalAuthUrl(channel_type: $channel_type) {
            url
        }
    }
`;

export const CONNECT_EXTERNAL_OAUTH_CALLBACK = `
    mutation ExternalAuthCallback($code: String!, $service: ExternalConnectEnum!) {
        externalAuthCallback(code: $code, service: $service) {
            user_name
            token
            new_user
        }
    }    
`;

export const UPDATE_USER_PASSWORD = `
    mutation UpdatePassword($password: String!, $password_confirmation: String!) {
        updatePassword(password: $password, password_confirmation: $password_confirmation) {
            user_name
            token
            new_user
        }
    }
`;
